module.exports = __webpack_public_path__ + "files/10583db7a248c9ea086a1b82e8e265b1.png";